import { createTheme, responsiveFontSizes } from '@material-ui/core';
import { green, teal, grey, red } from '@material-ui/core/colors';
import { Shadows } from '@material-ui/core/styles/shadows';

const PRIMARY_COLOR = teal;
const PRIMARY_COLOR_DARK = PRIMARY_COLOR["400"];
const PRIMARY_COLOR_LIGHT = PRIMARY_COLOR["300"];
const PRIMARY_COLOR_MAIN = PRIMARY_COLOR["600"];
const SECONDARY_COLOR = green;
const BACKGROUND_COLOR = grey;
const BACKGROUND_COLOR_FOCUS = grey[200];
let ERROR_COLOR = red;
let theme = createTheme({

  //shadows: Array(25).fill('none') as Shadows,
  palette: {
    primary: {
      main: PRIMARY_COLOR_MAIN,
      light: PRIMARY_COLOR_LIGHT,
      dark: PRIMARY_COLOR_DARK
    },
    secondary: SECONDARY_COLOR,
    error: ERROR_COLOR,
    background: {
      default: BACKGROUND_COLOR[50],
      paper: "#FFF",
    },
    divider: '#ddd',

  },
  spacing: 4,
  typography: {
    fontFamily: ['Roboto', 'Helvetica', 'Arial', '"Helvetica Neue"', '"sans-serif"'].join(','),
    h1: {
      fontSize: '112px',
      fontWeight: 200, //Light
    },
    h2: {
      fontSize: '56px',
      fontWeight: 'normal',
    },
    h3: {
      fontSize: '45px',
      fontWeight: 'normal',
    },
    h4: {
      fontSize: '34px',
      fontWeight: 'normal',
    },
    h5: {
      fontSize: '24px',
      fontWeight: 'normal',
    },
    h6: {
      fontSize: '20px',
      fontWeight: 400, //Medium
    },
    subtitle1: {
      fontSize: '16px',
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: '16px',
      fontWeight: 700,
    },

    body1: {
      fontSize: '16px',
      '@media (max-width:400px)': {
        fontSize: '14px',
      },
      fontWeight: 'normal',
    },
    body2: {
      fontSize: '12px',
      fontWeight: 400, //Medium
    },
    button: {
      fontSize: '14px',
      fontWeight: 400, //Medium,
    },

    caption: {
      fontSize: '12px',
      fontWeight: 'normal',
    },
    overline: {
      fontSize: '10px',
      fontWeight: 'normal',
    },
  },
  overrides: {
    MuiGrid: {
      container: {
        '&$spacing-xs-3': {
          margin: 0,
          width: '100%',
        },
        container: {
          width: "100% !important",
          margin: "0 !important"
        }
      },
    },
    MuiInput: {
      underline: {
        '&:not($disabled):before': {
          height: 0,
          color: '#e8e8e8',
          '&$error': {
            color: '#dd2c00',
            height: 0,
          },
        },
        '&:hover:not($disabled):before': {
          borderBottomColor: '#e8e8e8',
          borderBottomWidth: 1,
        },
        '&:after': {
          color: '#e8e8e8',
        },
        '&:before': {
          borderBottomColor: '#e8e8e8',
        },
      },
      root: {
        fontSize: '90%',
        color: '#333',
        '&$error': {
          fontWeight: 200,
          fontSize: '12px',
        },
      },
    },
    MuiBadge: {
      badge: {
        fontSize: "0.85em"
      }
    },
    MuiButtonBase: {
      root: {
        fontWeight: 500,
        paddingLeft: "8px",
        paddingRight: "8px"
      },
    },
    MuiFormLabel: {
      root: {
        color: '#0008',
        paddingBottom: '16px',
        paddingLeft: '3px',
      },
    },
    MuiTabs: {
      root: {
        borderBottom: '1px solid #e8e8e8',
      },
      indicator: {
        marginBottom: "1px",
        height: "2px"
      }
    },
    MuiFormHelperText: {
      root: {
        position: 'absolute',
        bottom: -19,
        fontWeight: 'lighter',
        fontSize: '12px',
        '&$error': {
          fontWeight: 200,
          color: '#CC0000',
        },
      },
    },
    MuiPaper: {
      root: {
        boxShadow: "1px 1px 12px 0px rgba(50, 50, 50, 0.5);"
      },
      elevation1: {
        boxShadow: "1px 1px 3px 0px rgba(50, 50, 50, 0.5);"
      },
      elevation2: {
        boxShadow: "1px 1px 6px 0px rgba(50, 50, 50, 0.5);"
      },
      elevation8: {
        boxShadow: "1px 1px 12px 0px rgba(50, 50, 50, 0.5);"
      }
    },
    MuiCheckbox: {
      colorPrimary: {
        color: 'secondary',
      },

      colorSecondary: {
        color: '#0008',
      },

    },
    MuiTooltip: {
      tooltip: {
        fontSize: '11px'
      }
    },
    MuiSwitch: {
      switchBase: {
        color: BACKGROUND_COLOR_FOCUS,
      },
      root: {
        "&$checked": {
          color: PRIMARY_COLOR_DARK,
        },
        "&$checked + $track": {
          color: PRIMARY_COLOR_LIGHT,
        }
      }

    },

    MuiChip: {
      root: {
        fontSize: 'large'
      }
    },
    MuiFormControlLabel: {
      root: {
        color: '#333'
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: '2rem'
      }
    },
    MuiListSubheader: {
      root: {
        fontSize: '2rem'
      }
    }
  },

});
theme = responsiveFontSizes(theme);

export default theme;
